import React, { useState } from 'react';
import { Box } from '../../styles/globalStyle';
import { Space,Radio } from 'antd';
import { theme, Text, ButtonAnt } from '@pfmam/pfmam';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const TextSemibold = styled(Text)`
  font-family: 'Inter Semibold';
`;

const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
  }
`;
const ButtonWrapper = styled(Space)`
  justify-content: space-between;
  width: 100%;
  min-width: 100%;
  margin-top: 16px;
  .primary {
    width: 160px;
  }
  ${(props) =>
    props.spacing &&
    css`
      margin-top: 48px;
    `}
`;



export const VerifyABALookupComponent = ({ accountType,bankNumbers,setStep}) => {
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const [bankName, setBankName] = useState();
  const [bankState, setBankState] = useState();
  const [abaNumber, setABANumber] = useState();
  const [bankCity, setBankCity] = useState();
  const history = useHistory();
  const [disableSubmit, setdisableSubmit] = useState(true);
  const [value, setValue] = useState(null);
  
  const onChange = (e) => {
    if(e.target.checked){
      setValue(e.target.value);
      setBankName(e.target.value.BankName);
      setBankState(e.target.value.BankState);
      setBankCity(e.target.value.BankCity);
      setABANumber(e.target.value.ABANumber);
      setdisableSubmit(false)
    }
  };
  const deselect=(e)=>{
    setValue(null);
    setdisableSubmit(true);
  }

  const getTexLabel=()=>{
    if (accountType === 'wire') {
      return "Wire ABA match found.";
    } else if (accountType === 'ach') {
      return "ACH ABA match found.";
    } else {
      return "No match found.";
  }
  }
  return (
    <>
  <Box
      boxcolor={primary_color}
      padding="24px 22px  14px"
      margin="0 -5px 32px"
    ></Box>
      <Box className="forms">
        <TextSemibold
          label={getTexLabel()}
           lineheight="32px"
            margin="0 125px 4px"
            fontSize={`${theme.font_size.size_3xl}`}
            color={`${theme.colors.black_secondary}`}
        />
        <Text
          label={"Confirm bank to continue or select Not A Match to return to search."}
          fontSize={`${theme.font_size.size_xl}`}
          lineheight="60px"
          color={`${theme.colors.black_secondary}`}
        />
        <Box>
          <Radio.Group onChange={onChange} value={value}>
            <Space direction="vertical">
            {bankNumbers.map((bankNumber) => (
                <Radio onClick={deselect} key={bankNumber.ABANumber} value={bankNumber}>
                   <b>{`${bankNumber.BankName}, ${bankNumber.BankCity}, ${bankNumber.BankState}`}</b>
                  </Radio>
              ))}
            </Space>
          </Radio.Group>
          <ButtonWrapper size={12} spacing>
            <ButtonAnt
              label="Not A Match"
              type="secondary"
              htmlType="button"
              onClick={() => {
                setStep(1);
              }}
            />  
            <OverrideButtonAnt
              linkTextColor={primary_color} label="Confirm Match" type="primary"
              disabled={disableSubmit}
              onClick={() => {
                if(accountType==='wire'){
                  history.push("/create-wire", {canNavigateInstruction:1, bankName: bankName, bankState: bankState, abaNumber: abaNumber, bankCity: bankCity });
                }
                else if(accountType==='ach'){
                  history.push("/create-ach", {canNavigateInstruction:1, bankName: bankName, bankState: bankState, abaNumber: abaNumber, bankCity: bankCity });
                }

              }}
            />
          </ButtonWrapper>
        </Box>
      </Box>
    </>
  )
}